import Grow from '@material-ui/core/Grow';
import Modal from '@material-ui/core/Modal';
export const ModalCustom = ({
  open,
  onClose,
  children,
  className,
}: {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <Modal
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      open={!!open}
      onClose={onClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <Grow in={!!open} timeout={500}>
        <div
          style={{
            overflow: 'hidden',
            borderRadius: '20px',
            border: '1px solid silver',
            boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
            outline: 'none',
            padding: '10px',
          }}
          className={className}
        >
          <div
            id={'modal-container'}
            style={{
              padding: '10px',
              overflowY: 'scroll',
              overflowX: 'hidden',
              height: '100%',
            }}
          >
            {children}
          </div>
        </div>
      </Grow>
    </Modal>
  );
};

export default ModalCustom;
